/**
 * The one sentence shown for a typed name made only of characters that render as nothing
 * (zero-width joiners, variation selectors, combining marks, and the like), found with
 * `hasVisibleContent` from `@steward-app/steward-types` (crossmarc/steward-app#2041).
 *
 * `trim()` does not remove those characters, so without a local check such a name reaches the
 * façade, which refuses it with a generic 400 whose reason the SPA never reads.
 *
 * Used by seven forms, listed 2026-10-03: `pages/settings/Profile.tsx`,
 * `components/NameNudge.tsx`, `firstrun/WelcomeOverlay.tsx`, `workspace/WorkspaceSettings.tsx`,
 * `workspace/NewWorkspaceDialog.tsx`, `workspace/FounderBootstrapDialog.tsx` and
 * `onboarding/OnboardingFlow.tsx`. Not used by the firm-name form (`advisor/YourFirm.tsx`, which
 * has its own sentence), nor by the entity, account or contact name forms, which were not in
 * scope. Also used, from 2026-10-16, by the passkey and authenticator-app name fields in
 * `mfa/FactorForms.tsx`. Not imported from `src/intake/` (checked by grep on 2026-10-03, not pinned by a test).
 */
export const INVISIBLE_NAME_MESSAGE = 'Please enter a name with at least one visible character.';
